import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";

function CerealsbgEdit(props) {
  console.log(props.value);

  const history = useNavigate();

  const [file6, setFile6] = useState(null);
  const [inputval6, setinputVal6] = useState({
    cerealsBackgroundimg:"",
    fname6: "",
    date: "",
  });

  const setData = (e) => {
    const { name, value } = e.target;
    setinputVal6((Data) => {
      return {
        ...Data,
        [name]: value,
      };
    });
  };
  const { id } = useParams("");
  console.log(id);
  const getData = async () => {
    const res6 = await fetch(`https://pratik-agro-backend.vercel.app/getCerealbgImg/${id}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });
    const data3 = await res6.json();

    if (res6.status === 422 || !data3) {
      console.log("error");
    } else {
      console.log(data3);
    setinputVal6({
        cerealsBackgroundimg: data3.cerealsBackgroundimg,
      fname6: data3.fname6,
      date: data3.date,
    });
  }
  };
  useEffect(() => {
    getData();
  }, []);

  const updateData6 = async (e) => {
    e.preventDefault();

    console.log(inputval6);

    var formData6 = new FormData();
    if (file6 != null) {
      formData6.append("image6", file6);
    }
    formData6.append("fname6", inputval6.fname6);
    formData6.append("date", inputval6.date);

    for (var pair of formData6.entries()) {
      console.log(pair[0] + ", " + pair[1]);
    }

    const config = {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    };

    axios
      .post(`https://pratik-agro-backend.vercel.app/updateCerealbgimg/${id}`, formData6, config)
      .then((res) => {
        if (res.status === 201) {
          console.log(res.data);
          history("/Cereals");
        }
      })
      .catch((error) => {
        if (error.response) {
          console.log(error.response);
        }
      });
  };
  return (
    <>
      <div className="content ">
        <div className="container mt-5 ">
          <Link className="btn btn-dark" to="/Cereals">
          <i class="bi bi-arrow-left-circle-fill"></i>
          </Link>
        </div>

        <form className="mx-auto mt-5 shadow p-5">
          <div className="container ">
            <h6>Fill This Form:-</h6>
          </div>
          <div className="mb-3 w-50 ">
            <label className="form-label">Background Image:</label>
            <input
              type="file"
              className="form-control"
              id="exampleInputEmail1"
              aria-describedby="emailHelp"
              name="image6"
              onChange={(e) => setFile6(e.target.files[0])}
              value={inputval6.image6}
            />
          </div>
          <div className="mb-3 w-50 ">
            <label className="form-label">Background Image Name: :</label>
            <input
              type="text"
              className="form-control"
              id="exampleInputEmail1"
              name="fname6"
              onChange={setData}
              value={inputval6.fname6}
            />
          </div>
          <div className="mb-3 w-50 ">
            <label className="form-label">Date:</label>
            <input
              type="text"
              className="form-control"
              id="exampleInputEmail1"
              aria-describedby="emailHelp"
              name="date"
              onChange={setData}
              value={inputval6.date}
            />
          </div>
          <div>
            <Link className="btn btn-success  mt-3" onClick={updateData6}>
              update Detail
            </Link>
          </div>
        </form>
      </div>
    </>
  );
}
export default CerealsbgEdit;